
import { 
  LineChart, 
  Line, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar
} from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

// Dados de exemplo para desempenho no trabalho
const performanceData = [
  { dia: 'Segunda', produtividade: 65, foco: 70, satisfacao: 60, eficiencia: 68, estresse: 75 },
  { dia: 'Terça', produtividade: 68, foco: 65, satisfacao: 62, eficiencia: 70, estresse: 72 },
  { dia: 'Quarta', produtividade: 60, foco: 58, satisfacao: 55, eficiencia: 62, estresse: 80 },
  { dia: 'Quinta', produtividade: 69, foco: 72, satisfacao: 67, eficiencia: 73, estresse: 69 },
  { dia: 'Sexta', produtividade: 75, foco: 68, satisfacao: 70, eficiencia: 69, estresse: 65 },
];

const radarData = [
  {
    subject: 'Produtividade',
    A: 68, // média da semana
    fullMark: 100,
  },
  {
    subject: 'Foco',
    A: 67,
    fullMark: 100,
  },
  {
    subject: 'Satisfação',
    A: 63,
    fullMark: 100,
  },
  {
    subject: 'Eficiência',
    A: 68,
    fullMark: 100,
  },
  {
    subject: 'Equilíbrio',
    A: 60,
    fullMark: 100,
  },
  {
    subject: 'Gerenciamento de Estresse',
    A: 72,
    fullMark: 100,
  },
];

const COLORS = {
  produtividade: '#60a5fa', // azul
  foco: '#8b5cf6', // roxo
  satisfacao: '#34d399', // verde
  eficiencia: '#f59e0b', // amarelo
  estresse: '#f87171', // vermelho
};

interface PerformanceChartProps {
  dateRange: {
    from: Date;
    to: Date;
  };
}

const PerformanceChart = ({ dateRange }: PerformanceChartProps) => {
  // We'll use the dateRange in the future to filter data
  // For now, we're just accepting the prop to fix the TypeScript error
  
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Desempenho no Trabalho</CardTitle>
        <CardDescription>Acompanhamento de métricas profissionais</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="linha" className="w-full">
          <TabsList className="mb-4">
            <TabsTrigger value="linha">Tendências Semanais</TabsTrigger>
            <TabsTrigger value="radar">Análise de Competências</TabsTrigger>
          </TabsList>
          
          <TabsContent value="linha" className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={performanceData}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="dia" />
                <YAxis label={{ value: 'Pontuação (0-100)', angle: -90, position: 'insideLeft' }} />
                <Tooltip />
                <Legend />
                <Line 
                  type="monotone" 
                  dataKey="produtividade" 
                  stroke={COLORS.produtividade} 
                  activeDot={{ r: 8 }} 
                />
                <Line 
                  type="monotone" 
                  dataKey="foco" 
                  stroke={COLORS.foco} 
                />
                <Line 
                  type="monotone" 
                  dataKey="satisfacao" 
                  stroke={COLORS.satisfacao} 
                />
                <Line 
                  type="monotone" 
                  dataKey="eficiencia" 
                  stroke={COLORS.eficiencia} 
                />
                <Line 
                  type="monotone" 
                  dataKey="estresse" 
                  stroke={COLORS.estresse} 
                />
              </LineChart>
            </ResponsiveContainer>
          </TabsContent>
          
          <TabsContent value="radar" className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <RadarChart cx="50%" cy="50%" outerRadius="80%" data={radarData}>
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" />
                <PolarRadiusAxis angle={30} domain={[0, 100]} />
                <Radar 
                  name="Semana atual" 
                  dataKey="A" 
                  stroke="#13265a" 
                  fill="#13265a" 
                  fillOpacity={0.6} 
                />
                <Tooltip />
                <Legend />
              </RadarChart>
            </ResponsiveContainer>
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default PerformanceChart;
